import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CODE_STATUS } from '@app/constant/CodeConstant'
import { usePage } from '@inertiajs/inertia-react'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { QRCodeCanvas } from 'qrcode.react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}

export default function VoucherCodeHistory() {
  const {
    props: { code_histories, routeName, voucher, importable },
  } = usePage()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [selectedCodeId, setSelectedCodeId] = useState(null)

  const handleOpenModal = (codeId) => {
    setSelectedCodeId(codeId)
    setOpen(true)
  }

  return (
    <Section simple>
      <DataGrid
        enableIndexColumn
        columns={[
          {
            id: 'code_id',
            Header: t('VOUCHER.CODE_ID'),
            accessor: 'code_id',
            type: 'string',
            Cell: ({ row }) => (
              <>
                <Typography
                  style={{
                    cursor: 'pointer',
                    color: '#0080ff',
                  }}
                  onClick={() => handleOpenModal(row.original.code_id)}
                >
                  {row.cells[1].value}
                </Typography>
                <Modal
                  open={open}
                  sx={{ '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.2)' } }}
                  onClose={() => setOpen(false)}
                >
                  <Box sx={style}>
                    <QRCodeCanvas id="qrCode" level={'H'} size={250} value={selectedCodeId} />
                    <Typography
                      id="modal-modal-description"
                      style={{ fontWeight: 'bold', fontSize: 23 }}
                      sx={{ mt: 4 }}
                    >
                      {selectedCodeId}
                    </Typography>
                  </Box>
                </Modal>
              </>
            ),
          },
          {
            id: 'status',
            Header: t('VOUCHER.STATUS'),
            accessor: ({ status }) => t(`CODES.${status.toUpperCase()}_HISTORY`),
            type: 'singleSelect',
            width: 70,
            options: [
              { value: CODE_STATUS.REDEEMED, name: t(`CODES.${CODE_STATUS.REDEEMED_NAME.toUpperCase()}_HISTORY`) },
              { value: CODE_STATUS.USED, name: t(`CODES.${CODE_STATUS.USED_NAME.toUpperCase()}_HISTORY`) },
              { value: CODE_STATUS.NEW, name: t(`CODES.${CODE_STATUS.NEW.toUpperCase()}_HISTORY`) },
            ],
          },
          {
            id: 'user_id',
            Header: t('VOUCHER.CUSTOMER_ID'),
            accessor: 'user_id',
            type: 'string',
            autoHide: true,
          },
          {
            id: 'created_at',
            Header: t('VOUCHER.TIME_TRANSACTION'),
            accessor: 'created_at',
            type: 'dateTime',
            autoHide: true,
          },
        ]}
        data={code_histories}
        enableCollapseFilter={false}
        importable={0 !== importable}
        params={{ merchant: voucher.merchant_id, voucher: voucher.id, tab: 'code_histories' }}
        queries={{
          merchant: voucher.merchant_id,
          voucher: voucher.id,
          tab: 'code_histories',
        }}
        routeName={routeName}
      />
    </Section>
  )
}
